export default __webpack_public_path__ + "static/media/services.4a70eb34.svg";